import React from 'react';
import { Sparkle } from 'lucide-react';

/**
 * Luxury ornamental divider: line — sparkle — line
 * Used as a consistent visual motif across section headers.
 */
const Ornament = ({ size = 20 }) => (
  <div className="lux-ornament" aria-hidden="true">
    <div className="lux-ornament-line"></div>
    <Sparkle size={size} className="lux-ornament-sparkle" />
    <div className="lux-ornament-line"></div>
  </div>
);

export default Ornament;
